import { Switch } from '@mui/material';
import React from 'react';
import { useTheme } from '@mui/material/styles';
import { toggleMode } from '../../store/reducers/settings';
import { useDispatch } from 'react-redux';

export default function DarkModeToggle() {
    const theme = useTheme();
    const dispatch = useDispatch();

    const toggleThemeMode = () => {
        dispatch(toggleMode({}));
    };

    return (
        <Switch
            checked={theme.palette.mode === 'dark'}
            onChange={toggleThemeMode}
        />
    );
}
